import { SUBSCRIPTION_URL } from 'constants'
import { auth } from 'constants/firebase'
import { displayError, displaySuccess } from 'components/NotificationController'

export function submitNewSubscription (planId, stripeData) {
  return function * (dispatch, getState) {
    try {
      // console.log('submitNewSubscription', stripeData)
      const authToken = yield auth.currentUser.getToken()

      const data = {
        authToken: authToken,
        planId,
        token: stripeData.id
      }
      // console.log('data', data)
      const response = yield fetch(SUBSCRIPTION_URL, {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      const resJson = yield response.json()
      if (resJson.error) {
        displayError(`subscribe error: ${resJson.error}`)
      } else {
        // console.log('server answer', resJson)
        displaySuccess(`You are successefuly subscribed to the ${resJson.plan.name} plan`)
      }
      // const answer = yield axios({
      //   method: 'post',
      //   url: url,
      //   data: data
      // })
      // // console.log('answer', answer)
      // if (answer.data.error) {
      //   // console.log('subscribe error', answer.data.error)
      //   message.error('Can`t process your request', 3)
      // } else if (answer.data.plan) {
      //   message.success(`You are successefuly subscribed to the ${answer.data.plan.name} plan`, 5)
      // }
    } catch (e) {
      // console.log('submitNewSubscription error', e)
      displayError('subscribe error:' + e.message)
    }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/payment.js